import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FormContainer from "components/form/FormContainer";
import { TeamReducerActions } from "reducers/teamReducer";
import ROUTES from "constants/Routes";

const TeamEditMember = () => {
  const formContent = {
    header: "Edit Team Member",
    inputs: [
      {
        label: "Name",
        fieldName: "name",
        required: true,
      },
      {
        label: "Title/Role",
        fieldName: "title_role",
      },
      {
        label: "Email",
        fieldName: "email",
        type: "email",
      },
      {
        label: "LinkedIn URL",
        fieldName: "linkedin_url",
        type: "url",
      },
      {
        label: "Twitter URL",
        fieldName: "twitter_url",
        type: "url",
      },
      {
        label: "Image",
        fieldName: "image",
        type: "file",
        avatar: "member",
      },
    ],
  };

  const { id } = useParams();
  const dispatch = useDispatch();
  const kit = useSelector((state) => state.auth.currentKit);
  const teamMemberData = useSelector((state) => state.team.selectedTeamMember);
  const {
    getSelectedTeamMemberData,
    setSelectedTeamMemberData,
    saveSelectedTeamMemberChanges,
  } = TeamReducerActions;

  const setTeamMemberData = (fieldName, value) => {
    dispatch(
      setSelectedTeamMemberData({ ...teamMemberData, [fieldName]: value })
    );
  };

  const handleSubmit = () => {
    dispatch(saveSelectedTeamMemberChanges(kit, teamMemberData));
  };

  useEffect(() => {
    if (kit) dispatch(getSelectedTeamMemberData(kit, id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kit]);

  return (
    <FormContainer
      formContent={formContent}
      data={teamMemberData}
      setNewData={setTeamMemberData}
      handleSubmit={handleSubmit}
      fileUpload={true}
      listPath={`${ROUTES.SETTINGS_PREFIX}${ROUTES.TEAM}`}
    />
  );
};

export default TeamEditMember;
